export default __webpack_public_path__ + "static/media/1637.70e34c47.png";